import { IRequestCommand } from "../../authentication/connection/iRequestCommand";
import {
  ErrorDetails
} from "../../authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";

export class DeleteServiceTypeCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteServiceTypeCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/{serviceTypeId}/delete';

  public setUrlParameters(carrierId: string, serviceTypeId: number) {
    this._commandUrl = this._commandUrl.replace(
      '{serviceTypeId}',
      serviceTypeId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      carrierId.toString()
    );
  }

  public override setParameters(parameters: IDeleteServiceTypeCommandParameters) {
    this._commandBody = parameters;
  }
}

export interface IDeleteServiceTypeCommandParameters
  extends ICommandParameters {
  userId: number;
}
